export const TIERS = [
  { min: 2500, title: 'Non-Human Skills', color: '#E879F9' },
  { min: 2000, title: 'Legendary', color: '#FACC15' },
  { min: 1800, title: 'Elite', color: '#A78BFA' },
  { min: 1500, title: 'Pro', color: '#38BDF8' },
  { min: 1000, title: 'Skilled', color: '#A3E635' },
  { min: 700, title: 'Rookie', color: '#FB923C' },
  { min: 0, title: 'Beginner', color: '#94A3B8' },
];

export const tierFor = (score) => TIERS.find((t) => score >= t.min);

export const nextTier = (score) => [...TIERS].reverse().find((t) => t.min > score);
